import { CenteredSpinner } from '@/common/components';

export default function LogoutPage() {
  return (
    <div style={{ height: '100vh', background: '#fff' }}>
      <CenteredSpinner message="Logging out" />;
    </div>
  );
}
